import { Badge } from '@pcln/horizon'
import type { ComponentProps } from 'react'

import type { LOCATION_SEARCH_TYPE } from '@/types'

import { getTypeaheadBadge } from './utils/getTypeaheadBadge'

type TypeaheadBadgeProps = {
  item: LOCATION_SEARCH_TYPE
  variant: string | undefined
}

const BADGE_LABELS = {
  popular: 'Popular',
  trending: 'Trending',
} as const

const BADGE_PALETTES = {
  popular: 'customer',
  trending: 'promoPrimary',
} as const satisfies Record<keyof typeof BADGE_LABELS, ComponentProps<typeof Badge>['palette']>

export default function TypeaheadBadge({ item, variant }: Readonly<TypeaheadBadgeProps>) {
  const badge = getTypeaheadBadge({ item, variant })
  if (!badge) return null

  return (
    <Badge palette={BADGE_PALETTES[badge]} size='sm'>
      {BADGE_LABELS[badge]}
    </Badge>
  )
}
